<template>
  <div class="ch-header-paper" id="ch-header-paper">
    <div class="top">
      <div class="filter">
          <div class="activities-search form-tg">
              <div class="activities-search-input activities-search-input--age">
                  <select name="activity[age_groups][]" v-model="filter.age" id="activity_age_groups_" class="form-control">
                      <option value="">全部年龄段</option>
                      <option :value="t.value" v-for="t in ages" :key="t.value">{{t.label}}</option>
                  </select>
              </div>
              <div class="activities-search-input activities-search-input--time">
                  <select name="activity[time_durations][]" v-model="filter.time" id="activity_time_durations_" class="form-control">
                      <option value="">全部时间</option>
                      <option :value="t.value" v-for="t in time" :key="t.value">{{t.label}}</option>
                  </select>
              </div>
              <div class="activities-search-input activities-search-input--skill">
                  <select name="activity[skills][]" v-model="filter.tag" id="activity_skills_" class="form-control">
                      <option value="">全部技能</option>
                      <optgroup :label="tag.label" v-for="tag in tags" :key="tag.type">
                          <option :value="t.id" v-for="t in tag.tags" :key="t.id">{{t.name}}</option>
                      </optgroup>
                  </select>
              </div>
              <!--<div class="activities-search-input activities-search-input&#45;&#45;keyword">-->
                  <!--<input type="text" name="keyword" id="activity_keyword" class="form-control" placeholder="游戏名称">-->
              <!--</div>-->
              <div class="activities-search-input activities-search-input--submit">
                  <input type="button" name="commit" value="搜索" @click="search" class="btn-tg btn-tg-orange btn-tg-full">
              </div>
          </div>
          <!--<input type="text" name="activity[keyword]" id="activity_keyword" value="" class="form-control" placeholder="Keyword">-->
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>

export default {
  name: "ActivityFilter",
  components: {
  },
  props: [],
    data() {
      return {
          time:[],
          tags:[],
          ages:[],
          filter:{time:'',tag:'',age:''},
      }
    },
    created() {
      this.$http.get('activities-filters')
          .then(({data}) => {
            console.log(data);
            this.time = data.time;
            this.tags = data.tags;
            this.ages = data.ages;
          });
    },
    methods: {
        search() {
            console.log(this.filter);
          this.$emit("onSearch", {...this.filter});
        },
    }
};
</script>

<style lang="scss" scoped>

</style>
